export default __webpack_public_path__ + "static/media/image-3.f16d3d2f.jpg";